import { LandingHero } from "@/components/flowly/Landing/LandingHero/LandingHero";
import { SocialProofStrip } from "@/components/flowly/Landing/SocialProofStrip/SocialProofStrip";

import { HowItWorks } from "@/components/flowly/Landing/HowItWorks/HowItWorks";
import { Testimonials } from "@/components/flowly/Landing/Testimonials/Testimonials";
import { CommunityGalleryPreview } from "@/components/flowly/Landing/CommunityGalleryPreview/CommunityGalleryPreview";
import { LandingFlowsShowcase } from "@/components/flowly/Landing/LandingFlowsShowcase/LandingFlowsShowcase";
import { PricingPreview } from "@/components/flowly/Landing/PricingPreview/PricingPreview";
import { FAQSection } from "@/components/flowly/Landing/FAQSection/FAQSection";
import { LandingCTA } from "@/components/flowly/Landing/LandingCTA/LandingCTA";
import { LandingCommunity } from "@/components/flowly/Landing/LandingCommunity/LandingCommunity";
import { COMMUNITY_ENABLED } from "@/config/featureFlags";

export const LandingPage = () => {
  return (
    <div className="flex flex-col">
      <LandingHero />
      <SocialProofStrip />
      <LandingFlowsShowcase />
      {COMMUNITY_ENABLED && <CommunityGalleryPreview />}
      <HowItWorks />
      <Testimonials />
      <LandingCommunity />
      <PricingPreview />
      <FAQSection />
      <LandingCTA />
    </div>
  );
};

export default LandingPage;
